export default __webpack_public_path__ + "static/media/aboutMe1.b741fdcd.svg";